<template>
  <div class="v-list-container" @click.capture="handleClick" @mousedown.capture="handleMouseDown" @mousemove.capture="handleMouseMove" @mouseup.capture="handleMouseUp">
    <van-pull-refresh ref="pullRefresh" v-model="refreshing" @refresh="reload" style="height: 100%" :disabled="disabled">
      <van-list v-model="loading" :finished="finished" :finished-text="list.length ? text : ''" :immediate-check="false" @load="onLoad" :class="[refreshing && 'lodingnone']">
        <slot></slot>
        <template v-if="$slots.loading" slot="loading">
          <slot name="loading"></slot>
        </template>
      </van-list>
      <slot name="empty" v-if="!list.length&&!loading">
        <div class="empty">
          <img src="@/assets/image/h5img/em.png" alt="">
          <p>没有数据哦~</p>
        </div>
      </slot>
    </van-pull-refresh>
    <div v-if="backTop && showBackTop" class="to_topaa" @click="scrollToTop">返回顶部</div>
  </div>
</template>

<script>
export default {
  props: {
    query: {
      type: Function,
      default: () => () => { }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '暂无更多'
    },
    // 只需要下拉刷新
    isrefresh: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: true
    },
    defaultPageSize: {
      type: Number,
      default: 10
    },
    backTop: {
      type: Boolean,
      default: false
    },
    backTopThreshold: {
      type: Number,
      default: 200
    },
    rememberScroll: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null
    }
  },

  computed: {
    isLo() {
      return document.querySelector('.van-loading')
    }
  },

  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      isDragging: false,
      startY: 0,
      lastY: 0,
      clickBlocked: false,
      showBackTop: false,
      scrollListenerTarget: null,
      savedScrollPosition: 0
    };
  },

  mounted() {
    if (this.isrefresh) this.finished = true
    if (this.auto && !this.isrefresh) {
      this.$nextTick(() => {
        this.reload()
      })
    }
    if (this.backTop) {
      this.$nextTick(() => {
        this.bindScrollListener()
      })
    }
  },

  activated() {
    if (this.backTop) this.bindScrollListener()
    if (this.rememberScroll && this.savedScrollPosition > 0) {
      this.$nextTick(() => {
        const scrollContainer = this.getScrollContainer()
        if (scrollContainer) scrollContainer.scrollTop = this.savedScrollPosition
        if (this.backTop) this.handleScroll()
      })
    }
  },

  deactivated() {
    if (this.rememberScroll) {
      this.savedScrollPosition = this.getScrollTop()
    }
    this.unbindScrollListener()
  },

  beforeDestroy() {
    if (this.rememberScroll) {
      this.savedScrollPosition = this.getScrollTop()
    }
    this.unbindScrollListener()
  },

  watch: {
    backTop(val) {
      if (val) {
        this.$nextTick(() => {
          this.bindScrollListener()
        })
      } else {
        this.showBackTop = false
        this.unbindScrollListener()
      }
    }
  },

  methods: {
    getScrollContainer() {
      const pullRefresh = this.$refs.pullRefresh
      if (pullRefresh && pullRefresh.$el) return pullRefresh.$el
      const el = this.$el && this.$el.querySelector && this.$el.querySelector('.van-pull-refresh')
      return el || null
    },
    bindScrollListener() {
      if (this.scrollListenerTarget) return

      const container = this.getScrollContainer()
      if (container) {
        this.scrollListenerTarget = container
        container.addEventListener('scroll', this.handleScroll, { passive: true })
        this.handleScroll()
        return
      }

      this.scrollListenerTarget = window
      window.addEventListener('scroll', this.handleScroll, { passive: true })
      this.handleScroll()
    },
    unbindScrollListener() {
      if (!this.scrollListenerTarget) return
      this.scrollListenerTarget.removeEventListener('scroll', this.handleScroll)
      this.scrollListenerTarget = null
    },
    getScrollTop() {
      const container = this.getScrollContainer()
      if (container) return container.scrollTop || 0
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    handleScroll() {
      const top = this.getScrollTop()
      this.showBackTop = top >= this.backTopThreshold
    },
    scrollToTop() {
      const container = this.getScrollContainer()
      this.showBackTop = false
      if (container && typeof container.scrollTo === 'function') {
        container.scrollTo({ top: 0 })
        return
      }
      if (container) {
        container.scrollTop = 0
        return
      }
      if (typeof window.scrollTo === 'function') {
        window.scrollTo({ top: 0 })
        return
      }
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    },
    getLimit() {
      return this.limit || this.defaultPageSize || 10
    },
    onLoad() {
      if (this.page === 1) {
        this.list = [];
      }
      this.$emit('query', this.page, this.getLimit())
    },
    complete(res) {
      this.loading = false;
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }

      if (!res) {
        this.finished = true;
        return;
      }
      this.list = this.list.concat(res);
      this.$emit('input', this.list);
      this.page++;
      if (res.length < this.getLimit()) {
        this.finished = true;
      }
    },
    reload() {
      if (this.isrefresh) {
        this.$emit('lodingFunc')
        return
      }
      // 清空列表数据
      this.list = [];
      this.$emit('input', [])
      this.finished = false;
      this.page = 1;
      // 重置滚动条位置
      this.$nextTick(() => {
        const scrollContainer = this.getScrollContainer()
        if (scrollContainer) scrollContainer.scrollTop = 0;
        this.showBackTop = false
        if (this.rememberScroll) this.savedScrollPosition = 0
      })
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    handleMouseDown(e) {
      this.isDragging = true;
      this.startY = e.clientY;
      this.clickBlocked = false;
    },

    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.lastY = e.clientY;
      if (Math.abs(this.lastY - this.startY) > 5) {
        this.clickBlocked = true;
      }
    },

    handleMouseUp() {
      this.isDragging = false;
    },

    handleClick(e) {
      if (e && e.target && e.target.closest && e.target.closest('.to_topaa')) return
      if (this.clickBlocked) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    suces() {
      this.loading = false;
      this.refreshing = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.v-list-container {
  height: 100%;
  width: 100%;
  padding-bottom: 2rem;
  position: relative;
}
.van-pull-refresh {
  overflow: inherit;
  flex: 1;
  &::-webkit-scrollbar {
    display: none;
  }
}
.v-list-back-top {
  position: absolute;
  right: 0.75rem;
  bottom: 3.5rem;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 1.1rem;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0rem 0.15rem 0.3rem 0.05rem rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  color: #8e8e8e;
  cursor: pointer;
  z-index: 10;
}
.lodingnone {
  ::v-deep .van-list__loading {
    display: none;
  }
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #aaaaaa;
  font-size: 0.6rem;
  img {
    width: 4.8rem;
    height: 4.8rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
}
.to_topaa {
  position: absolute;
  z-index: 9;
  width: 3.4rem;
  height: 1.2rem;
  background: #ffffff;
  box-shadow: 0 0.15rem 0.3rem 0.05rem rgba(0, 0, 0, 0.16);
  border-radius: 0.6rem 0.6rem 0.6rem 0.6rem;
  top: 1.2rem;
  left: 50%;
  transform: translateX(-50%);
  color: #8e8e8e;
  font-size: 0.6rem;
  text-align: center;
  line-height: 1.2rem;
  .back-to-top-text {
    font-size: 0.6rem;
    color: #000;
  }
}
</style>
